import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { LiveConferenceFinishSetupResponse } from '~client/model/live-conference-finish-setup-response';
import { LiveConferenceUserAcceptResponse } from '~client/model/live-conference-user-accept-response';
import { LiveConferenceUserDeclineResponse } from '~client/model/live-conference-user-decline-response';
import { LiveConferenceUserLeaveResponse } from '~client/model/live-conference-user-leave-response';
import { LiveConferenceUserRegisterResponse } from '~client/model/live-conference-user-register-response';

export class LiveConferenceUserController extends BaseController {
  /* Updates user's live conference state to an accepted state and returns vendor's token */
  public accept$(eventId: string): Observable<LiveConferenceUserAcceptResponse> {
    return this.post$('/streaming/conference/live/user/accept', {
      eventId,
      supportsAcceptedState: true,
    });
  }

  /* Updates user's live conference state to a declined state */
  public decline$(eventId: string): Observable<LiveConferenceUserDeclineResponse> {
    return this.post$('/streaming/conference/live/user/decline', { eventId });
  }

  /* Registers the user for video conference */
  public register$(eventId: string): Observable<LiveConferenceUserRegisterResponse> {
    return this.post$('/streaming/conference/live/user/register', { eventId });
  }

  /* Updates user's live conference state to waiting if accepted and returns vendor token */
  /* supportsAcceptedState is for backward compatibility and should always be true. It will eventually be removed. */
  public finishSetup$(eventId: string): Observable<LiveConferenceFinishSetupResponse> {
    return this.post$('/streaming/conference/live/user/finishedSetup', {
      eventId,
      supportsAcceptedState: true,
    });
  }

  public leave$(eventId: string): Observable<LiveConferenceUserLeaveResponse> {
    return this.post$('/streaming/conference/live/user/leave', { eventId });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/live-conference-user-controller.ts